import { Avatar, Menu } from '@fruuit/ui'
import { ChevronDown, CircleHelp, LogOut, UserRound } from 'lucide-react'
import { signOut } from '../api/session'
import { roleSummary } from '../areas/areas'
import { useSession } from '../auth/session-context'
import { exitImpersonation } from '../features/auth/api'

export function UserMenu() {
  const me = useSession()
  const name = me.user.display_name || me.user.email

  return (
    <Menu
      align="end"
      header={
        <div className="min-w-0">
          <p className="truncate text-sm font-semibold text-ink">{name}</p>
          <p className="truncate text-xs text-sage">{me.user.email}</p>
          <p className="mt-1.5 text-xs font-medium text-teal-600">{roleSummary(me)}</p>
        </div>
      }
      items={[
        { id: 'account', label: 'Account & security', href: '/account', icon: <UserRound /> },
        { id: 'help', label: 'Help', href: '/help', icon: <CircleHelp /> },
        {
          id: 'signout',
          label: me.impersonated_by ? 'Exit impersonation' : 'Sign out',
          icon: <LogOut />,
          onSelect: () => void (me.impersonated_by ? exitImpersonation() : signOut()),
        },
      ]}
      trigger={(props) => (
        <button
          {...props}
          className="flex items-center gap-2 rounded-full py-1 pr-2 pl-1 text-sm text-ink transition-colors hover:bg-wash aria-expanded:bg-wash"
        >
          {/* Named by content, not aria-label, so the visible name is part of it (WCAG 2.5.3). */}
          <span className="sr-only">Account menu for {name}</span>
          <Avatar name={name} size="sm" />
          <span aria-hidden="true" className="hidden max-w-40 truncate font-medium xl:block">
            {name}
          </span>
          <ChevronDown aria-hidden="true" className="size-4 text-sage" />
        </button>
      )}
    />
  )
}
